
export interface Solution {
  id: string;
  title: string;
  agency: "GSA" | "Education" | "NOAA";
  creator: string;
  creatorAvatar?: string;
  nftCoverImageUrl?: string;
  commercialType: "Sale" | "Lease" | "Collaborate" | "Stake";
  category: string;
  basePrice: number;
  price: number;
  description: string;
  capturedDate?: string;
  image?: string;
}

export const AGENCIES = {
  GSA: "General Services Administration",
  Education: "Department of Education",
  NOAA: "National Oceanic and Atmospheric Administration"
};

// Commercial type pricing factors
export const PRICE_FACTORS = {
  Sale: 1.0,    // 100% of base price
  Lease: 0.1,   // 10% of base price
  Collaborate: 0.2, // 20% of base price
  Stake: 0.5    // 50% of base price
};
